import React, { useEffect, useState } from 'react';
import moment from 'moment';

import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  TextField,
} from '@material-ui/core';
import { ContactPhone, Save } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';
import SweetAlert from 'react-bootstrap-sweetalert';

import { wsGetAll, wsCreate } from 'services/WService';
import { Toasty, useToasty } from 'hooks/Toasty';
import { Fragment } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import stylesForm from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';

const useStyles = makeStyles((theme) => ({
  ...styles,
  ...stylesForm,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  paper: {
    padding: theme.spacing(1),
    marginBottom: '15px',
  },
  marginRight: {
    float: 'right',
    marginBottom: '10px',
  },
  personType: {
    marginBottom: '20px',
    width: '100%',
  },
}));

export default WithApp(function NewBpartner(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const [alert, setAlert] = useState(null);
  const [docTypeInput, setDocTypeInput] = useState({});
  const [processing, setProcessing] = useState(false);
  const [ubigeos, setUbigeos] = useState([]);

  const { saveButton = true, incomplete = false, onSubmit = undefined, zoneId = undefined } = props;
  const urlIsCustomer = props.queryType === 'C' ? true : false;

  const { businessPartner } = props;
  const [bPartner, setBPartner] = useState({ ...props.model });
  const [start, setStart] = useState(0);

  async function getUbigeo() {
    let response = await wsGetAll('base/ubigeo');
    if (response.success) {
      setUbigeos(response.data);
    }
  }

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setBPartner((bPartner) => ({ ...bPartner, [name]: value }));
    if (props.setBusinessPartner !== undefined) {
      props.setBusinessPartner((bp) => ({ ...bp, [name]: value }));
    }
  };
  //preguntar si quiere ir a ver el detalle
  function showAlert(id) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Desea ver el socio creado?"
        onConfirm={() => {
          window.location = urlIsCustomer
            ? '/admin/socio-negocio/datos-maestros/clientes/' + id
            : '/admin/socio-negocio/datos-maestros/proveedor/' + id;
        }}
        onCancel={() => {
          setAlert(null);
          props.reload();
        }}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        ¡Luego puede regresar a seguir agregando!
      </SweetAlert>,
    );
  }

  //#region listados
  const [documentTypes, setDocumentTypes] = useState([]);
  const [currencys, setCurrencys] = useState([]);
  const [personTypes, setPersonTypes] = useState([]);
  const [taxs, setTaxs] = useState([]);
  const [priceLists, setPriceLists] = useState([]);
  const [countries, setCountries] = useState([]);
  const [banks, setBanks] = useState([]);

  async function listDocumentType() {
    let response = await wsGetAll('base/document-type');
    if (response.success) {
      setDocumentTypes(response.data);
      setDocTypeInput(response.data.find((item) => item.id == (urlIsCustomer ? 2 : 4)));
    }
  }
  async function listCurrency() {
    let response = await wsGetAll('base/currency');
    if (response.success) {
      setCurrencys(response.data);
    }
  }
  async function listPersonType() {
    let response = await wsGetAll('base/person-type');
    if (response.success) {
      setPersonTypes(
        urlIsCustomer
          ? response.data
          : response.data.filter((item) => item.code === 'TPJ' || item.code === 'TPN'),
      );
    }
  }
  async function listTaxs() {
    let response = await wsGetAll('base/tax');
    if (response.success) {
      setTaxs(response.data);
    }
  }
  async function priceList() {
    let response = await wsGetAll('logi/price-list?with_zone_id=Y');
    if (response.success) {
      setPriceLists(response.data);
    }
  }

  async function listCountries() {
    let response = await wsGetAll('base/country');
    if (response.success) setCountries(response.data);
  }

  async function listBanks() {
    let response = await wsGetAll('base/bank');
    if (response.success) {
      setBanks(response.data);
    }
  }
  //#endregion

  const changePersonType = (e) => {
    const {
      CardFName,
      CardName,
      U_SYP_BPNO,
      U_SYP_BPN2,
      U_SYP_BPAP,
      U_SYP_BPAM,
      ...rest
    } = bPartner;
    if (e.target.value === "1" || e.target.value === 1) {
      setBPartner({
        ...rest,
        base_document_type_id: 4,
        base_person_type_id: e.target.value,
      });
      setDocTypeInput(documentTypes.find((item) => item.id == 4));
    } else if (e.target.value === 2 && urlIsCustomer || e.target.value === "2" && urlIsCustomer) {
      setBPartner({
        ...rest,
        base_document_type_id: 2,
        base_person_type_id: e.target.value,
      });
      setDocTypeInput(documentTypes.find((item) => item.id == 2));
    } else {
      handleChange(e);
    }
  };

  async function saveBPartner(bPartnerData) {
    // Validar campos obligatorios
    // despues poner trim xd
    if (bPartnerData.QryGroup1 === 'N') {
      delete bPartnerData.prefix;
      delete bPartner.QryGroup2;
    }
    if (bPartnerData.base_person_type_id == 2) {
      let CardName = `${bPartnerData.U_SYP_BPAP} ${bPartnerData.U_SYP_BPAM} ${bPartnerData.U_SYP_BPNO}`;
      if (bPartnerData.U_SYP_BPN2 !== undefined && bPartnerData.U_SYP_BPN2.length > 0) {
        CardName = `${CardName} ${bPartnerData.U_SYP_BPN2}`;
      }
      bPartnerData = {
        ...bPartnerData,
        CardFName: CardName,
        CardName,
      };
    }
    setProcessing(true);
    let response = await wsCreate('base/business-partner', bPartnerData);
    if (response.success) {
      showAlert(response.data.id);
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
    setProcessing(false);
  }

  useEffect(() => {
    if (start > 0) return;
    if (props.businessPartner === undefined) return;
    if (Object.keys(props.businessPartner).length === 0) return;
    setStart((start) => start + 1);
    setBPartner((bp) => {
      let bpData = { ...props.businessPartner };
      if (zoneId !== undefined && priceLists.length > 0) {
        let priceList = priceLists.find((priceList) => parseInt(priceList.zoneId || 0) === zoneId);
        if (priceList !== undefined) {
          bpData.ListNum = priceList.ListNum;
        }
      }
      if (bpData.base_document_type_id === 2 || bpData.base_document_type_id === "2") {
        let dataSplit = bpData.CardName.split(' ');
        let data = [];
        // Juntando apellidos compuestos que empiezan por 'de'
        if (dataSplit.find((text) => text.toLowerCase() === 'de') !== undefined) {
          for (let i = 0; i < dataSplit.length; i++) {
            let name = dataSplit[i];
            if (dataSplit[i].toLowerCase() === 'de' && dataSplit[i + 1] !== undefined) {
              name = `${name} ${dataSplit[i + 1]}`;
              i++;
            }
            data.push(name);
          }
        } else {
          data = dataSplit;
        }
        switch (data.length) {
          case 1:
            bpData.U_SYP_BPNO = data[0];
            break;
          case 2:
            bpData.U_SYP_BPNO = data[0];
            bpData.U_SYP_BPAP = data[1];
            break;
          case 3:
            bpData.U_SYP_BPAP = data[0];
            bpData.U_SYP_BPAM = data[1];
            bpData.U_SYP_BPNO = data[2];
            break;
          case 4:
            bpData.U_SYP_BPAP = data[0];
            bpData.U_SYP_BPAM = data[1];
            bpData.U_SYP_BPNO = data[2];
            bpData.U_SYP_BPN2 = data[3];
            break;
          case 5:
            bpData.U_SYP_BPAP = data[0];
            bpData.U_SYP_BPAM = data[1];
            bpData.U_SYP_BPNO = data[2];
            bpData.U_SYP_BPN2 = `${data[3]} ${data[4]}`;
            break;
        }
      }
      return {
        ...bp,
        ...bpData,
      };
    });
  }, [props.businessPartner, zoneId, priceLists]);

  useEffect(() => {
    getUbigeo();
    listDocumentType();
    listCurrency();
    listTaxs();
    priceList();
    listCountries();
    listBanks();
    listPersonType();
  }, []);

  const [mappingDone, setMappingDone] = useState(false);

  useEffect(() => {
    if(mappingDone) return;
    if(props.businessPartner !== undefined && Object.keys(props.businessPartner).length > 0) {
      setMappingDone(true);
      setBPartner((bp) => ({
        ...bp,
        ...props.businessPartner,
        U_SYP_BPAP: props.businessPartner.father_name || props.businessPartner.U_SYP_BPAP || '',
        U_SYP_BPAM: props.businessPartner.mothert_name || props.businessPartner.U_SYP_BPAM || '',
        U_SYP_BPNO: props.businessPartner.first_name || props.businessPartner.U_SYP_BPNO || '',
        U_SYP_BPN2: props.businessPartner.second_name || props.businessPartner.U_SYP_BPN2 || '',
      }));
    }
  }, [props.businessPartner]);


  return (
    <Fragment>
      {alert}
      <Toasty action={notify} />
      <GridContainer>
        <form
          id="new-bpartner-form"
          onSubmit={(e) => {
            e.preventDefault();
            if (onSubmit !== undefined) {
              onSubmit(bPartner);
            } else {
              saveBPartner(bPartner);
            }
          }}
        >
          <GridItem xl={12}>
            <Card>
              <CardHeader icon>
                <CardIcon color={props.themeContext.buttonColor}>
                  <ContactPhone></ContactPhone>
                </CardIcon>
                <h4 className={classes.cardIconTitle}>General</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12} className={classes.personType}>
                    <GridContainer>
                      <GridItem xs={12} md={4}>
                        <FormControl fullWidth margin="normal" size="small" required>
                          <InputLabel>Tipo Persona </InputLabel>
                          <Select
                            value={bPartner.base_person_type_id || ''}
                            onChange={(e) => changePersonType(e)}
                            inputProps={{
                              name: 'base_person_type_id',
                            }}
                          >
                            {personTypes.map((personType, i) => {
                              return (
                                <MenuItem value={personType.id} key={i}>
                                  {personType.description}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} md={4}>
                        <FormControl
                          fullWidth
                          margin="normal"
                          size="small"
                          key={bPartner.base_person_type_id}
                          required
                        >
                          <InputLabel>Tipo Documento </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu,
                            }}
                            value={bPartner.base_document_type_id || ''}
                            inputProps={{
                              name: 'base_document_type_id',
                              onChange: handleChange,
                            }}
                            disabled={bPartner.base_person_type_id == 1}
                          >
                            {documentTypes.map((documentType, i) => {
                              return (
                                <MenuItem
                                  value={documentType.id}
                                  key={i}
                                  onClick={() => setDocTypeInput(documentType)}
                                >
                                  {documentType.description_short}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} md={4}>
                        <TextField
                          key={docTypeInput.id}
                          label={docTypeInput.description_short}
                          name="LicTradNum"
                          required
                          error={bPartner.LicTradNum == ''}
                          value={bPartner.LicTradNum || ''}
                          fullWidth
                          margin="normal"
                          size="small"
                          inputProps={{
                            onChange: handleChange,
                            minLength: docTypeInput.validation || 8,
                            maxLength: docTypeInput.validation || 15,
                          }}
                          onKeyPress={(e) => {
                            var key = window.event ? e.which : e.keyCode;
                            if (key < 48 || key > 57) {
                              return e.preventDefault();
                            }
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                  </GridItem>
                  {bPartner.base_person_type_id == 2 ? (
                    <GridItem xs={12} sm={6} md={6} lg={4}>
                      <Paper className={classes.paper}>
                        <TextField
                          error={bPartner.U_SYP_BPNO == '' ? true : false}
                          label="Primer Nombre"
                          name="U_SYP_BPNO"
                          defaultValue={bPartner.first_name || bPartner.U_SYP_BPNO || ''}
                          fullWidth
                          required
                          margin="normal"
                          size="small"
                          inputProps={{
                            onChange: handleChange,
                            pattern: '[a-zA-Z ]{2,254}',
                          }}
                        />
                        <TextField
                          label="Segundo Nombre"
                          name="U_SYP_BPN2"
                          defaultValue={bPartner.second_name || bPartner.U_SYP_BPN2 || ''}
                          fullWidth
                          margin="normal"
                          size="small"
                          inputProps={{
                            onChange: handleChange,
                            pattern: '[a-zA-Z ]{2,254}',
                          }}
                        />
                        <TextField
                          label="Apellido Paterno"
                          name="U_SYP_BPAP"
                          defaultValue={bPartner.father_name || bPartner.U_SYP_BPAP || ''}
                          fullWidth
                          required
                          margin="normal"
                          size="small"
                          inputProps={{
                            onChange: handleChange,
                            pattern: '[a-zA-Z ]{2,254}',
                          }}
                        />
                        <TextField
                          label="Apellido Materno"
                          name="U_SYP_BPAM"
                          defaultValue={bPartner.mothert_name || bPartner.U_SYP_BPAM || ''}
                          fullWidth
                          required
                          margin="normal"
                          size="small"
                          inputProps={{
                            onChange: handleChange,
                            pattern: '[a-zA-Z ]{2,254}',
                          }}
                        />
                        <TextField
                          label="Correo"
                          name="E_Mail"
                          type="email"
                          value={bPartner.E_Mail || ''}
                          fullWidth
                          margin="normal"
                          size="small"
                          inputProps={{ onChange: handleChange }}
                        />
                        <TextField
                          label="Celular"
                          name="Cellular"
                          value={bPartner.Cellular || ''}
                          fullWidth
                          margin="normal"
                          size="small"
                          inputProps={{
                            onChange: handleChange,
                            minLength: 9,
                            maxLength: 9,
                          }}
                        />
                      </Paper>
                    </GridItem>
                  ) : undefined}
                  <GridItem xs={12} sm={6} md={6} lg={4}>
                    <Paper className={classes.paper}>
                      <FormControl fullWidth margin="normal" size="small">
                        <InputLabel>Tipo Socio</InputLabel>
                        <Select
                          value={
                            urlIsCustomer
                              ? (bPartner.CardType = 'C')
                              : (bPartner.CardType = 'S' || '')
                          }
                          inputProps={{
                            name: 'CardType',
                            onChange: handleChange,
                          }}
                          disabled
                        >
                          <MenuItem value="C">Cliente</MenuItem>
                          <MenuItem value="S">Proveedor</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        label="Nombre Comercial"
                        name="CardFName"
                        margin="normal"
                        size="small"
                        inputProps={{ onChange: handleChange }}
                        InputLabelProps={{
                          shrink: true /* bPartner.base_person_type_id == 2 ? true : false */,
                        }}
                        fullWidth
                        disabled={bPartner.base_person_type_id == 2}
                        value={
                          bPartner.base_person_type_id == 2 &&
                          bPartner.U_SYP_BPNO &&
                          bPartner.U_SYP_BPAP &&
                          bPartner.U_SYP_BPAM !== undefined
                            ? `${bPartner.U_SYP_BPAP} ${bPartner.U_SYP_BPAM} ${bPartner.U_SYP_BPNO}${bPartner.U_SYP_BPN2 !== undefined ? ` ${bPartner.U_SYP_BPN2}` : ''}`
                            : bPartner.CardFName || ''
                        }
                        required
                      />
                      <TextField
                        label="Nombre Socio Negocio"
                        name="CardName"
                        margin="normal"
                        size="small"
                        required
                        inputProps={{ onChange: handleChange }}
                        InputLabelProps={{
                          shrink: true /* bPartner.base_person_type_id == 2 ? true : false */,
                        }}
                        fullWidth
                        disabled={bPartner.base_person_type_id == 2}
                        value={
                          bPartner.base_person_type_id == 2 &&
                          bPartner.U_SYP_BPNO &&
                          bPartner.U_SYP_BPAP &&
                          bPartner.U_SYP_BPAM !== undefined
                            ? `${bPartner.U_SYP_BPAP} ${bPartner.U_SYP_BPAM} ${bPartner.U_SYP_BPNO}${bPartner.U_SYP_BPN2 !== undefined ? ` ${bPartner.U_SYP_BPN2}` : ''}`
                            : bPartner.CardName || ''
                        }
                      />
                      <TextField
                        label="Dirección"
                        name="Address"
                        value={bPartner.Address || ''}
                        fullWidth
                        required
                        margin="normal"
                        size="small"
                        inputProps={{ onChange: handleChange }}
                      />
                      <TextField
                        label="Referencia"
                        name="reference"
                        value={bPartner.reference || ''}
                        fullWidth
                        required
                        margin="normal"
                        size="small"
                        inputProps={{ onChange: handleChange }}
                      />
                      <Autocomplete
                        fullWidth
                        options={ubigeos}
                        value={ubigeos.find((item) => item.id === bPartner.base_ubigeo_id) || null}
                        getOptionLabel={(option) => {
                          return `${option.U_SYP_DEPA}, ${option.U_SYP_PROV}, ${option.U_SYP_DIST}`;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Ubigeo"
                            margin="normal"
                            size="small"
                            required
                          />
                        )}
                        onChange={(e, item) => {
                          setBPartner((bp) => ({ ...bp, base_ubigeo_id: item?.id }));
                        }}
                      />
                      <FormControl fullWidth margin="normal" size="small" required>
                        <InputLabel>Tipo Moneda</InputLabel>
                        <Select
                          MenuProps={{
                            className: classes.selectMenu,
                          }}
                          value={bPartner.base_currency_id || ''}
                          inputProps={{
                            name: 'base_currency_id',
                            onChange: handleChange,
                          }}
                        >
                          {currencys.map((currency, i) => {
                            return (
                              <MenuItem value={currency.id} key={i}>
                                {currency.CurrName}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>

                      {urlIsCustomer ? (
                        <>
                          <FormControl fullWidth margin="normal" size="small">
                            <InputLabel>Aplica interés en órdenes al crédito</InputLabel>
                            <Select
                              value={bPartner.QryGroup4 || 'N'}
                              inputProps={{
                                name: 'QryGroup4',
                                onChange: handleChange,
                              }}
                            >
                              <MenuItem value="Y">Si</MenuItem>
                              <MenuItem value="N">No</MenuItem>
                            </Select>
                          </FormControl>
                          {bPartner.base_person_type_id !== 1 ? (
                            <FormControl fullWidth margin="normal" size="small">
                              <InputLabel>Socio es empleado</InputLabel>
                              <Select
                                value={bPartner.QryGroup5 || 'N'}
                                inputProps={{
                                  name: 'QryGroup5',
                                  onChange: handleChange,
                                }}
                              >
                                <MenuItem value="Y">Si</MenuItem>
                                <MenuItem value="N">No</MenuItem>
                              </Select>
                            </FormControl>
                          ) : undefined}

                          <FormControl fullWidth margin="normal" size="small">
                            <InputLabel>Clientes varios</InputLabel>
                            <Select
                              value={bPartner.QryGroup7 || 'N'}
                              required
                              inputProps={{
                                name: 'QryGroup7',
                                onChange: handleChange,
                              }}
                            >
                              <MenuItem value="Y">Si</MenuItem>
                              <MenuItem value="N">No</MenuItem>
                            </Select>
                          </FormControl>
                        </>
                      ) : (
                        <>
                          <FormControl fullWidth margin="normal" size="small">
                            <InputLabel>Socio es empleado</InputLabel>
                            <Select
                              value={bPartner.QryGroup5 || 'N'}
                              inputProps={{
                                name: 'QryGroup5',
                                onChange: handleChange,
                              }}
                            >
                              <MenuItem value="Y">Si</MenuItem>
                              <MenuItem value="N">No</MenuItem>
                            </Select>
                          </FormControl>

                          <FormControl fullWidth margin="normal" size="small">
                            <InputLabel>Proveedores varios</InputLabel>
                            <Select
                              value={bPartner.QryGroup7 || 'N'}
                              required
                              inputProps={{
                                name: 'QryGroup7',
                                onChange: handleChange,
                              }}
                            >
                              <MenuItem value="Y">Si</MenuItem>
                              <MenuItem value="N">No</MenuItem>
                            </Select>
                          </FormControl>

                          <FormControl fullWidth margin="normal" size="small">
                            <InputLabel>Proveedor de mercadería</InputLabel>
                            <Select
                              value={bPartner.QryGroup1 || 'N'}
                              inputProps={{
                                name: 'QryGroup1',
                                onChange: handleChange,
                              }}
                            >
                              <MenuItem value="Y">Si</MenuItem>
                              <MenuItem value="N">No</MenuItem>
                            </Select>
                          </FormControl>

                          {bPartner.QryGroup1 === 'Y' ? (
                            <>
                              <TextField
                                label="Prefijo"
                                name="prefix"
                                value={bPartner.prefix || ''}
                                margin="normal"
                                size="small"
                                inputProps={{ onChange: handleChange }}
                                fullWidth
                              />
                              <FormControl fullWidth margin="normal" size="small">
                                <InputLabel>Reconocimiento Desc.</InputLabel>
                                <Select
                                  value={bPartner.QryGroup2 || 'N'}
                                  inputProps={{
                                    name: 'QryGroup2',
                                    onChange: handleChange,
                                  }}
                                >
                                  <MenuItem value="Y">Si</MenuItem>
                                  <MenuItem value="N">No</MenuItem>
                                </Select>
                              </FormControl>
                            </>
                          ) : undefined}

                          <FormControl fullWidth margin="normal" size="small">
                            <InputLabel>Proveedor de Vehículo</InputLabel>
                            <Select
                              value={bPartner.QryGroup3 || 'N'}
                              inputProps={{
                                name: 'QryGroup3',
                                onChange: handleChange,
                              }}
                            >
                              <MenuItem value="Y">Si</MenuItem>
                              <MenuItem value="N">No</MenuItem>
                            </Select>
                          </FormControl>
                        </>
                      )}
                    </Paper>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6} lg={4}>
                    <Paper className={classes.paper}>
                      <FormControl fullWidth margin="normal" size="small">
                        <InputLabel>Recibo por honorarios</InputLabel>
                        <Select
                          value={bPartner.QryGroup6 || 'N'}
                          required
                          inputProps={{
                            name: 'QryGroup6',
                            onChange: handleChange,
                          }}
                        >
                          <MenuItem value="Y">Si</MenuItem>
                          <MenuItem value="N">No</MenuItem>
                        </Select>
                      </FormControl>

                      {urlIsCustomer ? undefined : (
                        <FormControl fullWidth margin="normal" size="small">
                          <InputLabel>Acreedor transportista</InputLabel>
                          <Select
                            value={bPartner.U_SYP_BPAT || 'N'}
                            required
                            inputProps={{
                              name: 'U_SYP_BPAT',
                              onChange: handleChange,
                            }}
                          >
                            <MenuItem value="Y">Si</MenuItem>
                            <MenuItem value="N">No</MenuItem>
                          </Select>
                        </FormControl>
                      )}

                      <FormControl fullWidth margin="normal" size="small">
                        <InputLabel>Sujeto a retención / detracción </InputLabel>
                        <Select
                          value={bPartner.WTLiable || 'N'}
                          required
                          inputProps={{
                            name: 'WTLiable',
                            onChange: handleChange,
                          }}
                        >
                          <MenuItem value="Y">Si</MenuItem>
                          <MenuItem value="N">No</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth margin="normal" size="small">
                        <InputLabel>Nuevo</InputLabel>
                        <Select
                          value={bPartner.new || ''}
                          required
                          inputProps={{
                            name: 'new',
                            onChange: handleChange,
                          }}
                        >
                          <MenuItem value="Y">Si</MenuItem>
                          <MenuItem value="N">No</MenuItem>
                        </Select>
                      </FormControl>
                      {/* <TextField
                        label="Código Socio Relacionado"
                        name="CardCode_relationed"
                        value={bPartner.CardCode_relationed || ''}
                        fullWidth
                        margin="normal"
                        size="small"
                        inputProps={{ onChange: handleChange }}
                      /> */}
                      <TextField
                        label="Fecha de alta"
                        type="date"
                        name="start_date"
                        value={bPartner.start_date || moment().format('YYYY-MM-DD')}
                        margin="normal"
                        size="small"
                        inputProps={{
                          onChange: handleChange,
                          min: moment().format('YYYY-MM-DD'),
                        }}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <FormControl fullWidth margin="normal" size="small">
                        <InputLabel>Estado</InputLabel>
                        <Select
                          value={bPartner.frozenFor || 'N'}
                          inputProps={{
                            name: 'frozenFor',
                            onChange: handleChange,
                          }}
                        >
                          <MenuItem value="N">Activo</MenuItem>
                          <MenuItem value="Y">Inactivo</MenuItem>
                        </Select>
                      </FormControl>

                      {/* <GridItem xs={12} sm={4} md={4} lg={2}> */}
                      <Autocomplete
                        options={priceLists}
                        getOptionLabel={(option) => option.ListName}
                        value={
                          priceLists.find((priceList) => priceList.ListNum === bPartner.ListNum) ||
                          null
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Lista precio"
                            margin="normal"
                            size="small"
                          />
                        )}
                        onChange={(e, item) => {
                          if (!!item) {
                            return setBPartner({
                              ...bPartner,
                              ListNum: item.ListNum,
                            });
                          }
                          setBPartner({
                            ...bPartner,
                            ListNum: null,
                          });
                        }}
                      />
                      {/* </GridItem> */}
                      {urlIsCustomer ? undefined : (
                        <FormControl fullWidth margin="normal" size="small">
                          <InputLabel>Evaluación cód. compras</InputLabel>
                          <Select
                            value={bPartner.item_frgn || '1'}
                            inputProps={{
                              name: 'item_frgn',
                              onChange: handleChange,
                            }}
                          >
                            <MenuItem value="1">Código externo 1</MenuItem>
                            <MenuItem value="2">Código externo 2</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    </Paper>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>

          {saveButton && (
            <GridItem xs={12}>
              <Button
                type="submit"
                round
                color={props.themeContext.buttonColorSuccess}
                className={classes.marginRight}
                disabled={processing}
              >
                <Save /> {processing ? 'Guardando' : 'Guardar'}
              </Button>
            </GridItem>
          )}
        </form>
      </GridContainer>
    </Fragment>
  );
});
